import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "formgrid grid" }
const _hoisted_3 = { class: "field col-2" }
const _hoisted_4 = { for: "since" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "p-error"
}
const _hoisted_7 = { class: "field col-1" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, " ", -1)

import Button from 'primevue/button'
import Panel from 'primevue/panel'
import Calendar from "primevue/calendar";

import {AxiosStatic} from "axios";
import {inject, reactive, ref} from "vue";
import {useRouter} from "vue-router";
import useVuelidate from "@vuelidate/core";
import {required} from "@vuelidate/validators";
import InputField from "@/components/blocks/InputField.vue";
import CompanyField from "@/components/blocks/CompanyField.vue";

// Define types
type FormData = {
  company: any | null
  since: string | null,
  amount: number | null
}

// Define component data

export default /*#__PURE__*/_defineComponent({
  __name: 'CreateRateForm',
  emits: ['itemCreated'],
  setup(__props, { emit: emits }) {

const formData = reactive<FormData>({
  company: null,
  since: null,
  amount: null
})

const formRef = ref(null)
const submitted = ref<boolean>(false)

const rules = {
  company: {required},
  since: {required},
  amount: {required}
}

// Define emits


// Inject dependencies
const axios = inject<AxiosStatic>('axios')

// Define used properties
const router = useRouter()
const v$ = useVuelidate(rules, formData)

// Define functions
function handleSubmit(isFormValid: boolean) {
  submitted.value = true
  if (isFormValid) {
    saveRate()
  } else {
    console.error('Form is not valid!')
  }
}

function saveRate() {
  axios?.post("/rate/create", buildData()).then((response) => {
    if (response.status >= 200 && response.status <= 299) {
      emits('itemCreated', response.data)
    } else {
      // message.error('Ulozeni spolecnosti se nezdarilo!')
      console.error(response)
    }
  })
}

function buildData(): any {
  return {
    rate: formData.amount,
    validSince: formData.since,
    companyId: formData.company.id
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Panel), {
    header: "Create Rate",
    toggleable: true,
    collapsed: true,
    class: "mt-2 mb-2"
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (handleSubmit(!_unref(v$).$invalid)), ["prevent"])),
        class: "p-fluid"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(CompanyField, {
              id: "company",
              class: "col-2",
              modelValue: formData.company,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.company) = $event)),
              vualidate: _unref(v$).company,
              submitted: submitted.value,
              label: "Company"
            }, null, 8, ["modelValue", "vualidate", "submitted"]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("label", _hoisted_4, [
                _createTextVNode("Plate od "),
                (_unref(v$).since.required)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, "*"))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_unref(Calendar), {
                id: "since",
                class: _normalizeClass({'p-invalid':_unref(v$).since.$invalid && submitted.value}),
                modelValue: formData.since,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.since) = $event))
              }, null, 8, ["class", "modelValue"]),
              (_unref(v$).$invalid && submitted.value)
                ? (_openBlock(), _createElementBlock("small", _hoisted_6, _toDisplayString(_unref(v$).since.required.$message.replace('Value', 'Platne od')), 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode(InputField, {
              id: "amount",
              class: "col-2",
              label: "Castka za MD",
              vualidate: _unref(v$).amount,
              submitted: submitted.value,
              modelValue: formData.amount,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.amount) = $event))
            }, null, 8, ["vualidate", "submitted", "modelValue"]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_unref(Button), {
                type: "submit",
                label: "Pridat",
                class: "p-button-lg"
              })
            ])
          ])
        ])
      ], 32)
    ]),
    _: 1
  }))
}
}

})